import { TagInterface } from 'riot';
import cadastreReportStore from '../../stores/cadastreReport';
import * as cadastreReportConstants from '../../constants/cadastreReport';
import landRegistryStore from '../../stores/landRegistry';
import * as landRegistryConstants from '../../constants/landRegistry';
import brokerLetterReportStore from '../../stores/brokerLetterReport';
import * as brokerLetterReportConstants from '../../constants/brokerLetterReport';

const { events: cadastreReportEvents } = cadastreReportConstants;
const { events: landRegistryEvents } = landRegistryConstants;
const { events: brokerLetterReportEvents } = brokerLetterReportConstants;

export interface ReportPrintToolbarTag extends TagInterface {
  printEnabled: boolean;
  printReport(): void;
}

export const init = (tag: ReportPrintToolbarTag): void => {
  const enablePrint = (): void => {
    tag.printEnabled = true;
    tag.update();
  };

  const triggerLoadFinish = (): void => {
    if (landRegistryStore.areAllLandRegistryTagsFinishedLoading() &&
      cadastreReportStore.isCadastreReportFinishedLoading()) {
      enablePrint();
    }
  };

  tag.printReport = (): void => {
    window.print();
  };

  tag.on('mount', () => {
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, triggerLoadFinish);
    landRegistryStore.on(landRegistryEvents.LAND_REGISTRY_LOADING_COMPLETE, triggerLoadFinish);
    brokerLetterReportStore.on(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADED, triggerLoadFinish);
  });

  tag.on('unmount', () => {
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, triggerLoadFinish);
    landRegistryStore.off(landRegistryEvents.LAND_REGISTRY_LOADING_COMPLETE, triggerLoadFinish);
    brokerLetterReportStore.off(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADED, triggerLoadFinish);
  });
};
